var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1062_6352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14769 13.7976C6.94462 13.823 6.74154 13.8501 6.53846 13.8788M7.14769 13.7976C10.1145 13.4254 13.1162 13.4254 16.0831 13.7976M7.14769 13.7976L6.82615 17.3269M16.0831 13.7976C16.2862 13.823 16.4892 13.8501 16.6923 13.8788M16.0831 13.7976L16.4046 17.3269M16.4046 17.3269L16.5984 19.4618C16.6104 19.5935 16.5948 19.7263 16.5526 19.8516C16.5104 19.977 16.4426 20.0922 16.3535 20.1898C16.2643 20.2875 16.1557 20.3655 16.0347 20.419C15.9138 20.4724 15.783 20.5 15.6507 20.5H7.58008C7.01992 20.5 6.58162 20.0194 6.63238 19.4618L6.82615 17.3269M16.4029 17.3269H17.3261C17.5762 17.327 17.8238 17.2779 18.0549 17.1822C18.286 17.0866 18.496 16.9464 18.6728 16.7696C18.8497 16.5928 18.99 16.3829 19.0858 16.1518C19.1815 15.9208 19.2308 15.6732 19.2308 15.4231V10.0974C19.2308 9.18269 18.5809 8.39238 17.6764 8.257C17.1383 8.17651 16.5986 8.10683 16.0577 8.048M6.82615 17.3269H5.90385C5.39891 17.3269 4.91466 17.1263 4.55762 16.7693C4.20058 16.4123 4 15.928 4 15.4231V10.0974C4 9.18269 4.64985 8.39238 5.55438 8.257C6.0925 8.17651 6.63217 8.10683 7.17308 8.048M16.0577 8.048C13.1049 7.72672 10.1259 7.72672 7.17308 8.048M16.0577 8.048V4.95192C16.0577 4.42646 15.6312 4 15.1058 4H8.125C7.59954 4 7.17308 4.42646 7.17308 4.95192V8.048M16.6923 10.9808H16.6991V10.9875H16.6923V10.9808ZM14.1538 10.9808H14.1606V10.9875H14.1538V10.9808Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1062_6352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.8bc85a2b29170970334df5a17d64320c.svg";
export { ForwardRef as ReactComponent };